import {BackendModule} from './../../../modules/backend.module';
import {FiltersService} from './../../../services/filters';
import {AuthService} from './../../../services/auth';
import {Component} from '@angular/core';
import {NavController, AlertController} from 'ionic-angular';
import {SessionService} from './../../../services/session';
import {ClassPage} from './../shared/class/class';


@Component({
  selector: 'page-my-classes',
  templateUrl: 'my-classes.html'
})
export class MyClassesPage {
  classPage = ClassPage;
  showPast = false;

  constructor(public navCtrl: NavController,
              public sessionService: SessionService,
              public authService: AuthService,
              public filtersService: FiltersService,
              public backendModule: BackendModule,
              public alertCtrl: AlertController) {
  }

  goToClass(classInfo) {
    this.navCtrl.push(this.classPage, {classInfo})
  }

  ionViewDidLoad() {
    window['page'] = 'MyClassesPage'; // for GA
  }

  seeMoreClasses() {
    if (this.filtersService.loadedAllmyClasses) {
      this.showPast = !this.showPast
    } else {
      this.backendModule.getAPI(`users/${this.sessionService.user.id}/lessons`)
        .subscribe(
          (result: any) => {
            this.sessionService.countClasses(result.lessons);
            this.filtersService.loadedAllmyClasses = true;
            this.showPast = !this.showPast
          },
          err => {
            this.sessionService.reportError(
              'myClassesPage',
              'seeMoreClasses()',
              err
            );
            let alert = this.alertCtrl.create({
              title: 'Error',
              subTitle: JSON.stringify(err),
              buttons: ['Ok']
            });
            alert.present();
          });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/my-classes/my-classes.ts